<div id="modal-header">
  <div id="modal-title">
    <mat-icon class="color-primary">warning</mat-icon>
    <span class="color-primary">{{ title | translate }}</span>
  </div>
  <button mat-icon-button class="color-primary mic-icon-button-large" (click)="closeModal()">
    <mat-icon class="color-primary">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <span>{{ description | translate }}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button (click)="closeModal()">
    {{ 'common.confirm-modal.cancel' | translate }}
  </button>
  <button color="warn" mat-flat-button [mat-dialog-close]="continue()">
    {{ 'common.confirm-modal.continue' | translate }}
  </button>
</mat-dialog-actions>
